const ROLE_ALIASES: Record<string, string> = {
  ADMIN: 'SYSTEM_ADMIN',
  SYS_ADMIN: 'SYSTEM_ADMIN',
  DON: 'REGISTERED_NURSE',
  CLINICIAN: 'CLINICAL_LEAD',
  HOME_CARE_COORDINATOR: 'CASE_MANAGER',
  SHIFT_LEADER: 'TEAM_LEADER',
  SHIFT_LEAD: 'TEAM_LEADER',
  REGION_COMPLIANCE: 'REGION_COMPLIANCE_OFFICER',
  REGION_FINANCE: 'REGION_FINANCE_OFFICER',
};

export function normalizeRole(role: string | null | undefined): string | null {
  if (!role) return null;
  const trimmed = role.trim();
  if (!trimmed) return null;
  const normalizedKey = trimmed.replace(/[\s-]+/g, '_').toUpperCase();
  const canonical = ROLE_ALIASES[normalizedKey] || normalizedKey;
  return canonical;
}

export function hasAnyRole(
  role: string | null | undefined,
  allowedRoles: readonly string[],
): boolean {
  const normalizedRole = normalizeRole(role);
  if (!normalizedRole) return false;
  return allowedRoles.map((candidate) => normalizeRole(candidate)).includes(normalizedRole);
}

export function isSystemAdmin(role: string | null | undefined): boolean {
  return normalizeRole(role) === 'SYSTEM_ADMIN';
}
